import api from "./api";

const route = "/applications";

const ApplicationsService = {
  postApplication: (data) => api.post(route, { ...data }),
};

export default ApplicationsService;
